// Google Translate (et d'autres extensions de traduction) réécrivent les
// nœuds texte du DOM en les enrobant dans des balises <font>, en dehors du
// contrôle de React. Quand React tente ensuite un removeChild/insertBefore
// sur un nœud dont le parent réel a changé, le navigateur lève une
// NotFoundError qui remonte jusqu'à l'ErrorBoundary racine (voir main.tsx) et
// casse le rendu de la page en cours (typiquement un formulaire en cours de
// saisie). On rend ces deux opérations tolérantes au lieu de les laisser
// crasher. Cf. https://github.com/facebook/react/issues/11538
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      if (child.parentNode) {
        return child.parentNode.removeChild(child) as T;
      }
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return originalInsertBefore.call(this, newNode, null) as T;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
